var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYahoo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.6358 2.00167C29.1764 8.35974 24.9255 14.8061 21.9798 19.6176C17.7996 12.8379 14.5457 7.64143 11.3154 2.00167C10.2341 2.24166 9.33305 2.30499 8.62232 2.30499C7.81558 2.30499 6.93811 2.24166 6 2C11.024 9.43802 15.3996 17.4044 19.7448 24.8124L19.4282 42C20.4623 41.8283 21.3162 41.695 21.9781 41.695C22.6737 41.695 23.5276 41.8283 24.5297 42L24.2131 24.8141C27.6034 18.946 35.2834 5.74318 38 2.00167C37.0669 2.22832 36.144 2.30665 35.2345 2.30665C34.3739 2.30499 33.5116 2.22832 32.6358 2.00167Z",
    fill: "#400393"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3159 2.00167C10.2346 2.24166 9.3334 2.30499 8.62259 2.30499C7.81577 2.30499 6.9382 2.24166 6 2C11.0245 9.43802 15.4006 17.4044 19.7463 24.8124L19.4296 42C20.4638 41.8283 21.3178 41.695 21.9798 41.695C21.9865 41.695 21.9933 41.695 22 41.695V19.5826C21.9933 19.5943 21.9865 19.6043 21.9798 19.6159C17.8008 12.8379 14.5466 7.64143 11.3159 2.00167Z",
    fill: "#380380"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYahoo);
export default __webpack_public_path__ + "static/media/yahoo.3c7c079a.svg";
export { ForwardRef as ReactComponent };